"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.visualizationIsBetaWarning = void 0;
/**
 * @internal
 */
function visualizationIsBetaWarning() {
    // eslint-disable-next-line no-console
    console.warn("This chart is not production-ready and may not provide the full functionality. Use it at your own risk.");
}
exports.visualizationIsBetaWarning = visualizationIsBetaWarning;
//# sourceMappingURL=logging.js.map